var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-roboto"},[_c('Breadcrumbs',{attrs:{"main":"","title":_vm.$t('lbl_EMPBE_Index')}}),_c('div',{staticClass:"container-fluid wrapper"},[_vm._v(" Welcome To Admin Panel! ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }